var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGanttCbChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2835_74899)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 5,
    fill: "#185CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3661 4.23431C13.6785 4.54673 13.6785 5.05327 13.3661 5.36569L6.96608 11.7657C6.65366 12.0781 6.14713 12.0781 5.83471 11.7657L2.63471 8.56569C2.32229 8.25327 2.32229 7.74673 2.63471 7.43431C2.94712 7.1219 3.45366 7.1219 3.76608 7.43431L6.40039 10.0686L12.2347 4.23431C12.5471 3.9219 13.0537 3.9219 13.3661 4.23431Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2835_74899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGanttCbChecked);
export default __webpack_public_path__ + "static/media/gantt-cb-checked.8ce0c4e05de1e0e10854109a39afc8b3.svg";
export { ForwardRef as ReactComponent };